/**
 * The one way a count is grouped for reading: the rail's (`en-IN`, so 2,50,000),
 * which the Players band uses too so that a figure never reads one way in the
 * sidebar and another beside it. A locale, not a rule — change it here and both
 * follow.
 */
export function grouped(n: number): string {
  return n.toLocaleString("en-IN");
}
